import {
  referralAttributionSchema,
  referralOwnerDetailSchema,
  referralsListResponseSchema,
  type ReferralAttribution,
  type ReferralOwnerDetail,
  type ReferralsListResponse,
} from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'
import type { ReferralFilters } from './filters.ts'

export const REFERRALS_PAGE_SIZE = 50

export function fetchReferrals(
  filters: ReferralFilters,
  perPage: number,
  signal?: AbortSignal,
): Promise<ReferralsListResponse> {
  const params = new URLSearchParams({
    owner_type: filters.ownerType,
    sort: filters.sort,
    page: String(filters.page),
    per_page: String(perPage),
  })
  if (filters.search) params.set('search', filters.search)
  if (filters.suspiciousOnly) params.set('suspicious', '1')

  return apiRequest(`/referrals?${params.toString()}`, { schema: referralsListResponseSchema, signal })
}

export const fetchReferral = (code: string, signal?: AbortSignal): Promise<ReferralOwnerDetail> =>
  apiRequest(`/referrals/${encodeURIComponent(code)}`, { schema: referralOwnerDetailSchema, signal })

export const revertAttribution = (id: number, reason: string): Promise<ReferralAttribution> =>
  apiRequest(`/referrals/attributions/${id}/revert`, {
    method: 'POST',
    body: { reason },
    schema: referralAttributionSchema,
  })
